import { Component } from '@angular/core';

@Component({
    selector: 'app-waiting-screen',
    templateUrl: './waiting-screen.component.html',
    styleUrls: ['./waiting-screen.component.scss'],
    standalone: false
})
export class WaitingScreenComponent {
  constructor() {}
}
